module.exports = __webpack_public_path__ + "images/emoji/japanese_castle.51fadfdb7e5f8cda9b27.png";